import { useState, useEffect } from "react";
import "../styles/Espaco.css";
import Separator from "./Separator/separator";
import ImgEspaco1 from "../assets/local/espaco1.jpeg";
import ImgEspaco2 from "../assets/local/espaco2.jpeg";
import ImgEspaco3 from "../assets/local/espaco3.jpeg";
import ImgEspaco4 from "../assets/local/espaco4.jpeg";

const espacos = [
  {
    id: 1,
    titulo: "Recepção",
    descricao: "Ambiente acolhedor e moderno para receber nossos pacientes com conforto e tranquilidade.",
    imagem: ImgEspaco4
  },
  {
    id: 2,
    titulo: "Consultório",
    descricao: "Equipamentos de última geração e ambiente climatizado para garantir o melhor atendimento.",
    imagem: ImgEspaco2
  },
  {
    id: 3,
    titulo: "Consultório",
    descricao: "Espaço preparado para realizar diversos procedimentos odontológicos com segurança e conforto.",
    imagem: ImgEspaco3
  },
  {
    id: 4,
    titulo: "Consultório",
    descricao: "Equipamentos de última geração e ambiente climatizado para garantir o melhor atendimento.",
    imagem: ImgEspaco1
  }
];

export default function Espaco() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(3);

  useEffect(() => {
    const updateVisibleSlides = () => {
      const width = window.innerWidth;
      if (width >= 1200) setVisibleSlides(3);
      else if (width >= 768) setVisibleSlides(2);
      else setVisibleSlides(1);
    };

    updateVisibleSlides();
    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % espacos.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + espacos.length) % espacos.length);
  };

  const extendedEspacos = [...espacos, ...espacos];
  const displayedEspacos = extendedEspacos.slice(currentIndex, currentIndex + visibleSlides);

  return (
    <section className="espaco" id="espaco">
      <div className="tit-sections mt-50">
        <h1>Nosso espaço</h1>
        <Separator />
        <h2>"Conheça as nossas instalações modernas e acolhedoras"</h2>
      </div>
      <div className="slider-container">
        <button className="carousel-btn" onClick={prevSlide}>&#10094;</button>
        <div className="slider">
          {displayedEspacos.map((espaco, index) => (
            <div key={index} className="slide">
              <img 
                src={espaco.imagem} 
                alt={espaco.titulo} 
              />
            </div>
          ))}
        </div>
        <button className="carousel-btn" onClick={nextSlide}>&#10095;</button>
      </div>
      <div className="carousel-indicators">
        {espacos.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
      <input 
        type="button"   
        onClick={(e) => {
          e.preventDefault();
          window.open("https://wa.me/5511930693338?text=Oi!%20Gostaria%20de%20receber%20atendimento.", "_blank");
          // Rastreamento de conversão do Google Ads
          if (window.gtag) {
            window.gtag('event', 'conversion', {
              'send_to': 'AW-16944490858/aL4_CM-jl7MaEOrS4Y8_',
              'value': 1
            });
          }
        }} 
        className="cta-button-transparent" 
        value="Entre em contato agora" 
      />
    </section>
  );
}